import React from 'react';
import MuiTextField from '@material-ui/core/TextField';
import { WarboxInputProps } from './types';

export const Input = ({ ...props }: WarboxInputProps) => {
    return (
        <MuiTextField
            {...props}
            InputLabelProps={{
                shrink: true,
            }}
            variant="outlined"
        />
    );
};
